import React from 'react';
interface StampBadgeProps {
  className?: string;
  color?: string;
  /** Slight rotation so it looks pressed by hand, not placed by a computer. */
  rotate?: number;
  /** Explicit pixel width — needed when the stamp is nested inside another SVG. */
  width?: number;
}
const RATIO = 132 / 264;

/** The bun spiral — our mark, wound by hand so the turns aren't even. */
function bunSpiral(cx: number, cy: number, rMax: number, turns = 2.2) {
  const steps = 72;
  let d = '';
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    const angle = t * turns * Math.PI * 2;
    const r = rMax * (1 - t) + Math.sin(angle * 2) * 0.6;
    const x = cx + Math.cos(angle) * r;
    const y = cy + Math.sin(angle) * r * 0.9;
    d += `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)} `;
  }
  return d.trim();
}

/** Sits right above the A, where the ring of an Å belongs. */
const SPIRAL = bunSpiral(122, 38, 13);

/**
 * The Småken stamp — one wonky inked box and the name, nothing else.
 * The bun doubles as the ring over the Å.
 */
export function StampBadge({
  className = 'w-44',
  color = '#E42616',
  rotate = -4,
  width
}: StampBadgeProps) {
  return <svg viewBox="0 0 264 132" className={width ? undefined : className} width={width} height={width ? Math.round(width * RATIO) : undefined} style={{
    transform: `rotate(${rotate}deg)`,
    transformOrigin: 'center'
  }} role="img" aria-label="Småken — smakat och godkänt" data-id="element-754" data-mp="1pq31ttiloe80">
      {/* One box, drawn by hand: lines that drift and corners that overshoot */}
      <path d="M16 18 C 90 13, 178 10, 250 12 M250 12 C 252 48, 251 86, 248 118 M248 118 C 176 122, 88 124, 14 120 M14 120 C 12 86, 13 50, 16 18" fill="none" stroke={color} strokeWidth="3.4" strokeLinecap="round" data-id="element-755" data-mp="1623u6rjc1n6t" />

      {/* The bun, doubling as the ring over the Å */}
      <path d={SPIRAL} fill="none" stroke={color} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-756" data-mp="2hh0x95ccqcx6" />

      {/* The name. The A is bare — the bun above is its ring. */}
      <text x="132" y="96" textAnchor="middle" fill={color} className="font-hand" fontSize="66" transform="rotate(-1.5 132 88)" data-id="element-757" data-mp="mcjavzj13acm">
        SMAKEN
      </text>
    </svg>;
}